import { useEffect, useState } from "react";
import { EditTwoTone } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  message,
  notification,
} from "antd";
import { callFetchUserByID, callUpdateUser } from "../../../../config/api";
import { createUser } from "../../../../types/backend";
import { ALL_GENDER } from "../../../../utils/constants/permissions";
import { useAppSelector } from "../../../../redux/hooks";
import moment from "moment";
import dayjs from "dayjs";
import { disabledDate } from "../../../../utils/library";
// import dayjs from "dayjs";

const ModalUser = ({
  record,
  handleFetchUser,
}: {
  record: any;
  handleFetchUser: any;
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [detailUser, setDetailUser] = useState<any>({});
  const roles = useAppSelector((state) => state?.role?.result);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const fetchUserById = async () => {
    const result: any = await callFetchUserByID(record?._id);
    setDetailUser(result.data);
  };
  useEffect(() => {
    fetchUserById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record?._id, record?.status]);

  const valueBirth = detailUser?.date_of_birth
    ? detailUser?.date_of_birth
    : moment().format("YYYY-MM-DD");

  const onFinish = async (values: createUser) => {
    values.status = status;
    const dataUpdate = {
      _id: record?._id,
      ...values,
    };

    const res: any = await callUpdateUser(dataUpdate);
    setLoading(true);
    try {
      if (res && res.statusCode === 200) {
        setDetailUser(res.data.result);
        handleFetchUser();
        fetchUserById();
        message.success("update success!");
        setOpen(false);
      } else {
        notification.error({
          message: "Đã có lỗi xảy ra",
          description: res.message,
        });
      }
    } catch {}
    setLoading(false);
  };

  const onChangeStatus = (checked: boolean) => {
    setStatus(checked);
  };

  useEffect(() => {
    form.setFieldsValue({
      ...detailUser,
      role: detailUser?.role?._id,
      date_of_birth: dayjs(valueBirth),
    });
    setStatus(detailUser?.status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [detailUser]);

  const roleSelect = roles.map((item) => {
    return { value: item._id, label: item.name };
  });

  return (
    <Spin spinning={loading}>
      <Button
        style={{ border: "1px solid #f57800" }}
        type="primary"
        ghost
        onClick={showModal}
      >
        <EditTwoTone twoToneColor="#f57800" style={{ cursor: "pointer" }} />
      </Button>
      <Modal
        title="Chỉnh sửa người dùng"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Lưu"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          hideRequiredMark
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: "Please enter email" }]}
              >
                <Input
                  // onChange={(e) => setName(e.target.value)}
                  placeholder="Please enter email"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="role"
                label="Role"
                rules={[{ required: true, message: "Please enter role" }]}
              >
                <Select
                  defaultValue={detailUser?.role?._id}
                  options={roleSelect}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter Name" }]}
              >
                <Input placeholder="Please enter name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="date_of_birth"
                label="Date of Birth"
                rules={[
                  { required: true, message: "Please enter date of birth" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  disabledDate={disabledDate}
                  format={"DD/MM/YYYY"}
                  placeholder="DD/MM/YYYY"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="avatar"
                label="Avatar"
                rules={[{ required: true, message: "Please enter url avatar" }]}
              >
                <Input
                  // onChange={(e) => setName(e.target.value)}
                  placeholder="Please enter avatar"
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: "Please enter address" }]}
              >
                <Input
                  // onChange={(e) => setName(e.target.value)}
                  placeholder="Please enter address"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[{ required: true, message: "Please enter gender" }]}
              >
                <Select defaultValue="" options={ALL_GENDER} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                // name="status"
                label="Trạng thái hoạt động"
                rules={[{ required: true, message: "Please enter status" }]}
              >
                <Switch checked={status} onChange={onChangeStatus} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalUser;
